import React from 'react';
import { Route, Routes } from 'react-router-dom';

import styles from './app.module.scss';
import PlanView from './views/plan/plan.view';
import RedeemGiftCardView from './views/redeem-gift-card/redeem-gift-card.view';
import OAuthProvider from './providers/oauth-provider';

function App() {
    //const theme = useThemeStore((state) => state.theme);

    return (
        <main id={styles.app}>
            <OAuthProvider>
                <Routes>
                    <Route path={'/'} element={<PlanView />} />
                    <Route
                        path={'/redeem-gift-card'}
                        element={<RedeemGiftCardView />}
                    />
                </Routes>
            </OAuthProvider>
        </main>
    );
}

export default App;
